import styled from '@emotion/styled';
import { Colors, media } from '@utex/ui-kit';

export const Container = styled('div')`
  @media ${media.phonablet} {
    --gap: 1.6rem;
  }
`;

export const TitleWrapper = styled('div')`
  padding: 2rem var(--gap) 1.8rem;
  border-bottom: 1px solid ${Colors.ut.border10};
`;
